import React from 'react';
import "./services.css";


const Services = () => {
    const [toggleState, setToggleState] = React.useState(0);
    const toggleTab = (index) => {
        setToggleState(index);     
    }

  return (
    <section className="services section" id="services">
        <h2 className="section__title">Services</h2>
        <span className="section__subtitle">What I offer</span>

        <div className="services__container container grid">
            <div className="services__content">
                <div>
                    <i className="uil uil-web-grid services__icon"></i>
                    <h3 className="services__title">Project Coordination </h3>
                </div>

                <span className="services__button" onClick={()=>toggleTab(1)}>View More
                    <i className="uil uil-arrow-right services__button-icon"></i>
                </span>

                <div className={toggleState === 1 ? "services__modal active-modal" : "services__modal"}>
                    <div className="services__modal-content">
                        <i onClick={()=>toggleTab(0)} className="uil uil-times services__modal-close"></i>

                        <h3 className="services__modal-title">Project Coordination/Management</h3>
                        <p className="services__modal-description">Overseeing all aspects of a project, from planning and execution to monitoring and completion. Ensuring projects are delivered on time, within budget, and to the required quality standards. This includes setting project goals, defining roles and responsibilities, managing resources, and facilitating communication among team members and stakeholders.</p>

                        {/* <ul className="services__modal-services grid">
                            <li className="services__modal-service">
                                <i className="uil uil-check-circle services__modal-icon"></i>
                                <p className="services__modal-info">I develop the user interface</p>
                            </li>   

                            <li className="services__modal-service">
                                <i className="uil uil-check-circle services__modal-icon"></i>
                                <p className="services__modal-info">I develop web page</p>
                            </li>   

                            <li className="services__modal-service">
                                <i className="uil uil-check-circle services__modal-icon"></i>
                                <p className="services__modal-info">I develop database</p>
                            </li>   
                        </ul> */}

                    </div>
                </div>

            </div>

            <div className="services__content">
                <div>
                    <i className="uil uil-arrow services__icon"></i>
                    <h3 className="services__title">Software Development</h3>
                </div>

                <span className="services__button" onClick={()=>toggleTab(2)}>View More
                    <i className="uil uil-arrow-right services__button-icon"></i>
                </span>

                <div className={toggleState === 2 ? "services__modal active-modal" : "services__modal"}>
                    <div className="services__modal-content">
                        <i onClick={()=>toggleTab(0)} className="uil uil-times services__modal-close"></i>

                        <h3 className="services__modal-title">Software Development</h3>
                        <p className="services__modal-description">I offer comprehensive development services, including designing, coding, and maintaining software applications to meet your business goals and user requirements. This involves writing clean, efficient code, debugging and testing software, and collaborating with other developers and stakeholders. As a full-stack developer, I create applications that ensure a seamless user experience and robust functionality. I stay updated with the latest technologies and best practices to deliver high-quality, scalable solutions.</p>

                        {/* <ul className="services__modal-services grid">
                            <li className="services__modal-service">
                                <i className="uil uil-check-circle services__modal-icon"></i>
                                <p className="services__modal-info">I devesssslop the user interface</p>
                            </li>   

                            <li className="services__modal-service">
                                <i className="uil uil-check-circle services__modal-icon"></i>
                                <p className="services__modal-info">I develop web page</p>
                            </li>   

                            <li className="services__modal-service">
                                <i className="uil uil-check-circle services__modal-icon"></i>
                                <p className="services__modal-info">I develop database</p>
                            </li>   
                        </ul> */}

                    </div>
                </div>

            </div>

            <div className="services__content">
                <div>
                    <i className="uil uil-edit services__icon"></i>
                    <h3 className="services__title">Business Analysis</h3>
                </div>

                <span className="services__button" onClick={()=>toggleTab(3)}>View More
                    <i className="uil uil-arrow-right services__button-icon"></i>
                </span>

                <div className={toggleState === 3 ? "services__modal active-modal" : "services__modal"}>
                    <div className="services__modal-content">
                        <i onClick={()=>toggleTab(0)} className="uil uil-times services__modal-close"></i>

                        <h3 className="services__modal-title">Business Analysis</h3>
                        <p className="services__modal-description">I offer business analysis services to help bridge the gap between the business needs and technical solutions. This includes gathering and analyzing data, documenting business processes, and translating business requirements into actionable technical specifications. By working closely with stakeholders, I ensure that technology solutions align with business goals, improve efficiency, and deliver value. Thus ensuring that the projects are well-defined, strategically planned, and effectively executed.</p>

                        {/* <ul className="services__modal-services grid">
                            <li className="services__modal-service">
                                <i className="uil uil-check-circle services__modal-icon"></i>
                                <p className="services__modal-info">I develop the user interface</p>
                            </li>   

                            <li className="services__modal-service">
                                <i className="uil uil-check-circle services__modal-icon"></i>
                                <p className="services__modal-info">I develop web page</p>
                            </li>   

                            <li className="services__modal-service">
                                <i className="uil uil-check-circle services__modal-icon"></i>
                                <p className="services__modal-info">I develop database</p>
                            </li>   
                        </ul> */}

                    </div>
                </div>

            </div>

        </div>

    </section>
  )
}

export default Services